import { GetAlarmsResponse, GetLossesBalanceResponse } from '@data';

export const GET_DEVICE_ALARMS_DATA = [
  {
    name: 'Detección corriente de fuga',
    values: [0, 1, 2],
  },
  {
    name: 'Voltaje de referencia',
    values: [0, 0, 0],
  },
  {
    name: 'Voltaje fallo alimentación',
    values: [2, 0, 5],
  },
  {
    name: 'Caída de voltaje',
    values: [0, 0, 0],
  },
  {
    name: 'Sobretensión',
    values: [1, 1, 0],
  },
];

export const GET_CATEGORY_ALARMS_DATA: GetAlarmsResponse = {
  data: {
    alarmsRsabtCount: 50,
    alarmsTsabtCount: 40,
    alarmsVtnCount: 10,
    alarmsRsabtActiveCount: 0,
    alarmsTsabtActiveCount: 0,
    alarmsVtnActiveCount: 0,
    alarmCategories: [
      {
        alarmCategory: 'powerQuality',
        deviceType: 'rsabt',
        count: 15,
        countActive: 15,
      },
      {
        alarmCategory: 'groundLeakage',
        deviceType: 'rsabt',
        count: 2,
        countActive: 2,
      },
      {
        alarmCategory: 'blownFuse',
        deviceType: 'tsabt',
        count: 6,
        countActive: 6,
      },
      {
        alarmCategory: 'blownFuse',
        deviceType: 'vtn',
        count: 62,
        countActive: 62,
      },
      {
        alarmCategory: 'powerQuality',
        deviceType: 'vtn',
        count: 3,
        countActive: 3,
      },
    ],
    alarms: [],
  },
  pagination: {
    currentPage: 1,
    currentItems: 1,
    perPage: 1,
    totalPages: 1,
    totalItems: 1,
  },
};

export const GET_ALARMS_DATA: any = {
  alarmsCount: 20,
  data: {
    alarms: [
      {
        distributorId: 'D001',
        centerId: '022.CTR.SG000678996',
        rsabtId: 'RSABT000678996',
        centerName: 'Main Hub',
        deviceType: 'rsabt',
        alarmCategory: 'leakageCurrent',
        alarmType: 'nominalCurrentRating',
        priority: 'high',
        dateInit: '2025-06-01T10:00:00Z',
        dateEnd: null,
        read: false,
        field: {
          name: 'Overload',
          value: 120,
          percentage: 120.0,
          referenceValue: 100,
          phase: 'R',
          unit: 'amperes',
        },
      },
      {
        distributorId: 'D002',
        centerId: '022.CTR.SG000678996',
        rsabtId: 'RSABT000678996',
        centerName: 'South Wing',
        deviceType: 'rsabt',
        alarmCategory: 'supplyQuality',
        alarmType: 'frequency',
        priority: 'medium',
        dateInit: '2025-06-01T14:00:00Z',
        dateEnd: '2025-08-01T15:30:00Z',
        read: true,
        field: {
          name: 'Voltage Drop',
          value: 180,
          percentage: 90.0,
          referenceValue: 200,
          phase: 'S',
          unit: 'volts',
        },
      },
      {
        distributorId: 'D003',
        centerId: '022.CTR.SG000678996',
        rsabtId: 'RSABT000678996',
        centerName: 'North Facility',
        deviceType: 'rsabt',
        alarmCategory: 'blownFuse',
        alarmType: 'fuseBlownByOverload',
        priority: 'low',
        dateInit: '2025-08-01T08:30:00Z',
        dateEnd: '2025-06-01T09:45:00Z',
        read: false,
        field: {
          name: 'Current Surge',
          value: 140,
          percentage: 140.0,
          referenceValue: 100,
          phase: 'T',
          unit: 'amperes',
        },
      },
      {
        distributorId: 'D004',
        centerId: '022.CTR.SG000678996',
        rsabtId: 'RSABT000678996',
        centerName: 'East Tower',
        deviceType: 'rsabt',
        alarmCategory: 'supplyQuality',
        alarmType: 'leakageCurrentDetection',
        priority: 'high',
        dateInit: null,
        dateEnd: null,
        read: true,
        field: {
          name: 'Temperature Spike',
          value: 85,
          percentage: 85.0,
          referenceValue: 100,
          phase: 'R',
          unit: 'degrees',
        },
      },
      {
        distributorId: 'D005',
        centerId: '022.CTR.SG000678996',
        rsabtId: 'RSABT000678996',
        centerName: 'West Plant',
        deviceType: 'rsabt',
        alarmCategory: 'leakageCurrent',
        alarmType: 'openFuse',
        priority: 'medium',
        dateInit: '2025-06-02T07:15:00Z',
        dateEnd: '2025-06-02T08:00:00Z',
        read: false,
        field: {
          name: 'Frequency Drop',
          value: 49.8,
          percentage: 99.6,
          referenceValue: 50,
          phase: 'S',
          unit: 'hertz',
        },
      },
      {
        distributorId: 'D006',
        centerId: '022.CTR.SG000678996',
        rsabtId: 'RSABT000678996',
        centerName: 'Central Storage',
        deviceType: 'rsabt',
        alarmCategory: 'supplyQuality',
        alarmType: 'voltageDrop',
        priority: 'high',
        dateInit: '2025-06-02T13:00:00Z',
        dateEnd: '2025-06-02T13:30:00Z',
        read: false,
        field: {
          name: 'Voltage Surge',
          value: 250,
          percentage: 125.0,
          referenceValue: 200,
          phase: 'R',
          unit: 'volts',
        },
      },
      {
        distributorId: 'D007',
        centerId: '022.CTR.SG000678996',
        rsabtId: 'RSABT000678996',
        centerName: 'West Distribution',
        deviceType: 'rsabt',
        alarmCategory: 'leakageCurrent',
        alarmType: 'voltageDrop',
        priority: 'medium',
        dateInit: '2025-06-02T09:00:00Z',
        dateEnd: '2025-06-02T09:45:00Z',
        read: true,
        field: {
          name: 'Leakage Detected',
          value: 15,
          percentage: 15.0,
          referenceValue: 100,
          phase: 'S',
          unit: 'amperes',
        },
      },
      {
        distributorId: 'D008',
        centerId: '022.CTR.SG000678996',
        rsabtId: 'RSABT000678996',
        centerName: 'North Storage',
        deviceType: 'rsabt',
        alarmCategory: 'supplyQuality',
        alarmType: 'nominalCurrentRating',
        priority: 'low',
        dateInit: '2025-06-02T14:30:00Z',
        dateEnd: '2025-06-02T15:15:00Z',
        read: true,
        field: {
          name: 'Frequency Surge',
          value: 52.5,
          percentage: 105.0,
          referenceValue: 50,
          phase: 'T',
          unit: 'hertz',
        },
      },
      {
        distributorId: 'D009',
        centerId: '022.CTR.SG000678996',
        rsabtId: 'RSABT000678996',
        centerName: 'East Distribution',
        deviceType: 'rsabt',
        alarmCategory: 'blownFuse',
        alarmType: 'neutralOvervoltageLevel2',
        priority: 'medium',
        dateInit: '2025-06-02T10:00:00Z',
        dateEnd: '2025-06-02T10:30:00Z',
        read: false,
        field: {
          name: 'Excessive Load',
          value: 200,
          percentage: 200.0,
          referenceValue: 100,
          phase: 'R',
          unit: 'amperes',
        },
      },
      {
        distributorId: 'D010',
        centerId: '022.CTR.SG000678996',
        rsabtId: 'RSABT000678996',
        centerName: 'South Facility',
        deviceType: 'rsabt',
        alarmCategory: 'leakageCurrent',
        alarmType: 'fuseBlownByShortCircuit',
        priority: 'high',
        dateInit: '2025-06-02T16:00:00Z',
        dateEnd: '2025-06-02T16:45:00Z',
        read: true,
        field: {
          name: 'Overheating',
          value: 95,
          percentage: 95.0,
          referenceValue: 100,
          phase: 'S',
          unit: 'degrees',
        },
      },
    ],
  },
};

export const GET_PANELS_ADMINISTRATION_DATA = [
  {
    id: 'alarmsConfig',
    active: true,
    checked: false,
    disabled: false,
    header: null,
    context: {
      title: 'ADMIN.CONFIGURATION_ALARM',
      preIcon: 'bell',
      checked: false,
      count: 0,
    },
    items: [
      {
        id: 'rsabt',
        header: 'DEVICE.RSABT',
        context: {
          count: 0,
        },
        active: true,
      },
      {
        id: 'tsabt',
        header: 'DEVICE.TSABT',
        context: {
          count: 0,
        },
        active: false,
      },
      {
        id: 'vtn',
        header: 'DEVICE.VTN',
        context: {
          count: 0,
        },
        active: false,
      },
    ],
  },
];

export const GET_CENTERS_SAVED_DATA: any = {
  pagination: {
    currentPage: 1,
    currentItems: 10,
    perPage: 10,
    totalPages: 1,
    totalItems: 4,
  },
  data: {
    centers: [
      {
        id: '4babc7e9-ca0a-4f7b-85e9-ea4add75b663',
        distributorId: '6efba616-0e31-499b-a133-316476da60f0',
        distributorCode: 'R1-278',
        centerId: '146.CTR.T600000030',
        centerName: 'CT_PEDAZO LA MULA',
        transformerName: 'TRF-01 PESO AREAS',
        transformerId: '022.TRF.XX00000263',
        lineId: '022.LBT.T500000030',
        lineName: 'Línea 1',
        deviceType: 'rsabt',
        enabled: true,
      },
      {
        id: '550e8400-e29b-41d4-a716-446655440000',
        distributorId: '6efba616-0e31-499b-a133-316476da60f0',
        distributorCode: '022',
        centerId: '022.CTR.6308354302',
        centerName: 'Centro Madrid Norte',
        transformerName: 'TRF-01 PESO AREAS',
        transformerId: '022.TRF.XX00000263',
        lineId: '022.LBT.T500000030',
        lineName: 'Línea Salida 1',
        deviceType: 'rsabt',
        enabled: true,
      },
      {
        id: '550e8400-e29b-41d4-a716-446655440001',
        distributorId: '6efba616-0e31-499b-a133-316476da60f0',
        distributorCode: '022',
        centerId: '022.CTR.6308354302',
        centerName: 'Centro Madrid Norte',
        transformerName: 'TRF-01 PESO AREAS',
        transformerId: null,
        lineId: null,
        lineName: 'Línea Salida 1',
        deviceType: 'rsabt',
        enabled: true,
      },
      {
        id: '550e8400-e29b-41d4-a716-446655440002',
        distributorId: '6efba616-0e31-499b-a133-316476da60f0',
        distributorCode: '022',
        centerId: '022.CTR.6308354302',
        centerName: 'Centro Madrid Norte',
        transformerName: null,
        transformerId: null,
        lineId: null,
        lineName: null,
        deviceType: 'rsabt',
        enabled: true,
      },
    ],
  },
};

export const LIST_TABLES_DRAWER_ADMIN: any = {
  rsabt: [
    {
      alarm_category_Id: 'groundLeakage',
      alarm_category: 'ALARMS.CATEGORY.GROUND_LEAKAGE',
      types: [
        {
          key: 'leakageCurrentDetection',
          referenceValue: 0,
          referenceValueUnit: 'a',
          alarmType: 'ALARMS.CATEGORY.LEAKAGE_CURRENT_DETECTION',
          duration: 1,
          durationUnit: 'hour',
          priority: 'medium',
          valueMinOperator: 'less',
          value_min: 5,
          valueMaxOperator: 'more',
          valueMax: 0,
          valuePercentage: false,
          deviceType: 'rsabt',
          alarm_category: 'groundLeakage',
          isRanged: false,
          hasReference: false,
        },
      ],
    },
    {
      alarm_category_Id: 'powerQuality',
      alarm_category: 'ALARMS.CATEGORY.POWER_QUALITY',
      types: [
        {
          key: 'powerFailureVoltage',
          referenceValue: 230,
          referenceValueUnit: 'v',
          alarmType: 'ALARMS.CATEGORY.POWER_FAILURE_VOLTAGE',
          duration: 1,
          durationUnit: 'hour',
          priority: 'low',
          valueMinOperator: 'lessEquals',
          value_min: 10,
          valueMaxOperator: 'more',
          valueMax: 0,
          valuePercentage: true,
          deviceType: 'rsabt',
          alarm_category: 'powerQuality',
          isRanged: false,
          hasReference: true,
        },
        {
          key: 'voltageDrop',
          referenceValue: 230,
          referenceValueUnit: 'v',
          alarmType: 'ALARMS.CATEGORY.VOLTAGE_DROP',
          duration: 1,
          durationUnit: 'hour',
          priority: 'high',
          valueMinOperator: 'lessEquals',
          value_min: 90,
          valueMaxOperator: 'more',
          valueMax: 0,
          valuePercentage: true,
          deviceType: 'rsabt',
          alarm_category: 'powerQuality',
          isRanged: false,
          hasReference: true,
        },
        {
          key: 'overVoltage',
          referenceValue: 230,
          referenceValueUnit: 'v',
          alarmType: 'ALARMS.CATEGORY.OVERVOLTAGE',
          duration: 1,
          durationUnit: 'hour',
          priority: 'high',
          valueMinOperator: 'moreEquals',
          value_min: 110,
          valueMaxOperator: 'more',
          valueMax: 0,
          valuePercentage: true,
          deviceType: 'rsabt',
          alarm_category: 'powerQuality',
          isRanged: false,
          hasReference: true,
        },
        {
          key: 'frequency',
          referenceValue: 0,
          referenceValueUnit: 'hz',
          alarmType: 'ALARMS.CATEGORY.FREQUENCY',
          duration: 1,
          durationUnit: 'hour',
          priority: 'medium',
          valueMinOperator: 'less',
          value_min: 49,
          valueMaxOperator: 'more',
          valueMax: 51,
          valuePercentage: false,
          deviceType: 'rsabt',
          alarm_category: 'powerQuality',
          isRanged: true,
          hasReference: false,
        },
        {
          key: 'criticFrequency',
          referenceValue: 0,
          referenceValueUnit: 'hz',
          alarmType: 'ALARMS.CATEGORY.CRITIC_FREQUENCY',
          duration: 1,
          durationUnit: 'hour',
          priority: 'high',
          valueMinOperator: 'less',
          value_min: 47.5,
          valueMaxOperator: 'more',
          valueMax: 52,
          valuePercentage: false,
          deviceType: 'rsabt',
          alarm_category: 'powerQuality',
          isRanged: true,
          hasReference: false,
        },
      ],
    },
  ],
  tsabt: [
    {
      alarm_category_Id: 'blownFuse',
      alarm_category: 'ALARMS.CATEGORY.BLOWN_FUSE',
      types: [
        {
          key: 'openFuse',
          referenceValue: 250,
          referenceValueUnit: 'a',
          alarmType: 'ALARMS.CATEGORY.OPEN_FUSE',
          duration: 1,
          durationUnit: 'hour',
          priority: 'medium',
          valueMinOperator: 'lessEquals',
          value_min: 60,
          valueMaxOperator: 'more',
          valueMax: 0,
          valuePercentage: true,
          deviceType: 'tsabt',
          alarm_category: 'blownFuse',
          isRanged: false,
          hasReference: true,
        },
        {
          key: 'fuseBlownByShortCircuit',
          referenceValue: 250,
          referenceValueUnit: 'a',
          alarmType: 'ALARMS.CATEGORY.FUSE_BLOWN_BY_SHORT_CIRCUIT',
          duration: 1,
          durationUnit: 'hour',
          priority: 'medium',
          valueMinOperator: 'moreEquals',
          value_min: 250,
          valueMaxOperator: 'more',
          valueMax: 0,
          valuePercentage: true,
          deviceType: 'tsabt',
          alarm_category: 'blownFuse',
          isRanged: false,
          hasReference: true,
        },
        {
          key: 'fuseBlownByOverload',
          referenceValue: 250,
          referenceValueUnit: 'a',
          alarmType: 'ALARMS.CATEGORY.FUSE_BLOWN_BY_OVERLOAD',
          duration: 1,
          durationUnit: 'hour',
          priority: 'medium',
          valueMinOperator: 'moreEquals',
          value_min: 120,
          valueMaxOperator: 'more',
          valueMax: 0,
          valuePercentage: true,
          deviceType: 'tsabt',
          alarm_category: 'blownFuse',
          isRanged: false,
          hasReference: true,
        },
      ],
    },
  ],
  vtn: [
    {
      alarm_category_Id: 'powerQuality',
      alarm_category: 'ALARMS.CATEGORY.POWER_QUALITY',
      types: [
        {
          key: 'neutralOvervoltageLevel1',
          referenceValue: 0,
          referenceValueUnit: 'v',
          alarmType: 'ALARMS.CATEGORY.NEUTRAL_OVERVOLTAGE_LEVEL_1',
          duration: 1,
          durationUnit: 'hour',
          priority: 'medium',
          valueMinOperator: 'more',
          value_min: 20,
          valueMaxOperator: 'more',
          valueMax: 50,
          valuePercentage: false,
          deviceType: 'vtn',
          alarm_category: 'powerQuality',
          isRanged: true,
          hasReference: false,
        },
        {
          key: 'neutralOvervoltageLevel2',
          referenceValue: 0,
          referenceValueUnit: 'v',
          alarmType: 'ALARMS.CATEGORY.NEUTRAL_OVERVOLTAGE_LEVEL_2',
          duration: 1,
          durationUnit: 'hour',
          priority: 'high',
          valueMinOperator: 'more',
          value_min: 50,
          valueMaxOperator: 'more',
          valueMax: 0,
          valuePercentage: false,
          deviceType: 'vtn',
          alarm_category: 'powerQuality',
          isRanged: false,
          hasReference: false,
        },
        {
          key: 'overTemperature',
          referenceValue: 0,
          referenceValueUnit: 'C',
          alarmType: 'ALARMS.CATEGORY.OVERTEMPERATURE',
          duration: 1,
          durationUnit: 'hour',
          priority: 'low',
          valueMinOperator: 'moreEquals',
          value_min: 70,
          valueMaxOperator: 'more',
          valueMax: 0,
          valuePercentage: false,
          deviceType: 'vtn',
          alarm_category: 'powerQuality',
          isRanged: false,
          hasReference: false,
        },
      ],
    },
  ],
};

export const DATA_CHART_LOSSES: any = {
  data: [
    {
      field: 'energyCT',
      points: [
        {
          x: 1764684000000,
          y: 263.90000000000003,
        },
        {
          x: 1764684300000,
          y: 279.9,
        },
        {
          x: 1764684600000,
          y: 274.09999999999997,
        },
        {
          x: 1764684900000,
          y: 260.6,
        },
        {
          x: 1764685200000,
          y: 260.3,
        },
        {
          x: 1764685500000,
          y: 262.1,
        },
        {
          x: 1764685800000,
          y: 281.7,
        },
        {
          x: 1764686100000,
          y: 280,
        },
        {
          x: 1764686400000,
          y: 274.4,
        },
        {
          x: 1764686700000,
          y: 241.90000000000003,
        },
        {
          x: 1764687000000,
          y: 253.3,
        },
        {
          x: 1764687300000,
          y: 268.2,
        },
        {
          x: 1764687600000,
          y: 281.2,
        },
        {
          x: 1764687900000,
          y: 288.1,
        },
        {
          x: 1764688200000,
          y: 312.90000000000003,
        },
        {
          x: 1764688500000,
          y: 294.50000000000006,
        },
        {
          x: 1764688800000,
          y: 303.29999999999995,
        },
        {
          x: 1764689100000,
          y: 329.1,
        },
        {
          x: 1764689400000,
          y: 309,
        },
        {
          x: 1764689700000,
          y: 295.9,
        },
        {
          x: 1764690000000,
          y: 314.5,
        },
        {
          x: 1764690300000,
          y: 333.8,
        },
        {
          x: 1764690600000,
          y: 333.70000000000005,
        },
        {
          x: 1764690900000,
          y: 355,
        },
        {
          x: 1764691200000,
          y: 337.19999999999993,
        },
        {
          x: 1764691500000,
          y: 350.1,
        },
        {
          x: 1764691800000,
          y: 368,
        },
        {
          x: 1764692100000,
          y: 378.70000000000005,
        },
        {
          x: 1764692400000,
          y: 354.59999999999997,
        },
        {
          x: 1764692700000,
          y: 389.7,
        },
        {
          x: 1764693000000,
          y: 378.3,
        },
        {
          x: 1764693300000,
          y: 389.7,
        },
        {
          x: 1764693600000,
          y: 401.80000000000007,
        },
        {
          x: 1764693900000,
          y: 405.5,
        },
        {
          x: 1764694200000,
          y: 414.70000000000005,
        },
        {
          x: 1764694500000,
          y: 383.90000000000003,
        },
        {
          x: 1764694800000,
          y: 385.7,
        },
        {
          x: 1764695100000,
          y: 378.9,
        },
        {
          x: 1764695400000,
          y: 369.8,
        },
        {
          x: 1764695700000,
          y: 348.29999999999995,
        },
        {
          x: 1764696000000,
          y: 365.2,
        },
        {
          x: 1764696300000,
          y: 382.4,
        },
        {
          x: 1764696600000,
          y: 367.8,
        },
        {
          x: 1764696900000,
          y: 380.5,
        },
        {
          x: 1764697200000,
          y: 377.79999999999995,
        },
        {
          x: 1764697500000,
          y: 379.90000000000003,
        },
        {
          x: 1764697800000,
          y: 383,
        },
        {
          x: 1764698100000,
          y: 367.59999999999997,
        },
        {
          x: 1764698400000,
          y: 365.1,
        },
        {
          x: 1764698700000,
          y: 372.6,
        },
        {
          x: 1764699000000,
          y: 348.8,
        },
        {
          x: 1764699300000,
          y: 332.9,
        },
        {
          x: 1764699600000,
          y: 361.8,
        },
        {
          x: 1764699900000,
          y: 341.7,
        },
        {
          x: 1764700200000,
          y: 344.8,
        },
        {
          x: 1764700500000,
          y: 379.9,
        },
        {
          x: 1764700800000,
          y: 367,
        },
        {
          x: 1764701100000,
          y: 358.90000000000003,
        },
        {
          x: 1764701400000,
          y: 396.70000000000005,
        },
        {
          x: 1764701700000,
          y: 384.5,
        },
        {
          x: 1764702000000,
          y: 383.7,
        },
        {
          x: 1764702300000,
          y: 387.30000000000007,
        },
        {
          x: 1764702600000,
          y: 371.8999999999999,
        },
        {
          x: 1764702900000,
          y: 364,
        },
        {
          x: 1764703200000,
          y: 363.29999999999995,
        },
        {
          x: 1764703500000,
          y: 350.2,
        },
        {
          x: 1764703800000,
          y: 333.09999999999997,
        },
        {
          x: 1764704100000,
          y: 342.7,
        },
        {
          x: 1764704400000,
          y: 323.7,
        },
        {
          x: 1764704700000,
          y: 305.09999999999997,
        },
        {
          x: 1764705000000,
          y: 344.7,
        },
        {
          x: 1764705300000,
          y: 326.6,
        },
        {
          x: 1764705600000,
          y: 280.8,
        },
        {
          x: 1764705900000,
          y: 308.79999999999995,
        },
        {
          x: 1764706200000,
          y: 310.7,
        },
        {
          x: 1764706500000,
          y: 284.59999999999997,
        },
        {
          x: 1764706800000,
          y: 282.29999999999995,
        },
        {
          x: 1764707100000,
          y: 276.1,
        },
        {
          x: 1764707400000,
          y: 258.4,
        },
        {
          x: 1764707700000,
          y: 278.59999999999997,
        },
        {
          x: 1764708000000,
          y: 273,
        },
        {
          x: 1764708300000,
          y: 248.80000000000004,
        },
        {
          x: 1764708600000,
          y: 272.2,
        },
        {
          x: 1764708900000,
          y: 256.1,
        },
        {
          x: 1764709200000,
          y: 236.6,
        },
        {
          x: 1764709500000,
          y: 230.7,
        },
        {
          x: 1764709800000,
          y: 212.79999999999998,
        },
        {
          x: 1764710100000,
          y: 196.29999999999998,
        },
        {
          x: 1764710400000,
          y: 225.7,
        },
        {
          x: 1764710700000,
          y: 212.9,
        },
        {
          x: 1764711000000,
          y: 230.4,
        },
        {
          x: 1764711300000,
          y: 240.99999999999997,
        },
        {
          x: 1764711600000,
          y: 232.7,
        },
        {
          x: 1764711900000,
          y: 215.3,
        },
        {
          x: 1764712200000,
          y: 211.7,
        },
        {
          x: 1764712500000,
          y: 199.1,
        },
        {
          x: 1764712800000,
          y: 185.8,
        },
        {
          x: 1764713100000,
          y: 207.70000000000002,
        },
        {
          x: 1764713400000,
          y: 200.6,
        },
        {
          x: 1764713700000,
          y: 176.79999999999998,
        },
        {
          x: 1764714000000,
          y: 186.20000000000002,
        },
        {
          x: 1764714300000,
          y: 182.4,
        },
        {
          x: 1764714600000,
          y: 168.70000000000002,
        },
        {
          x: 1764714900000,
          y: 184.2,
        },
        {
          x: 1764715200000,
          y: 182.6,
        },
        {
          x: 1764715500000,
          y: 171.89999999999998,
        },
        {
          x: 1764715800000,
          y: 170.4,
        },
        {
          x: 1764716100000,
          y: 197.60000000000002,
        },
        {
          x: 1764716400000,
          y: 190.29999999999995,
        },
        {
          x: 1764717000000,
          y: 173.40000000000003,
        },
        {
          x: 1764717300000,
          y: 158.2,
        },
        {
          x: 1764717600000,
          y: 174.1,
        },
        {
          x: 1764717900000,
          y: 174.7,
        },
        {
          x: 1764718200000,
          y: 157.3,
        },
        {
          x: 1764718500000,
          y: 157.29999999999998,
        },
        {
          x: 1764718800000,
          y: 158.1,
        },
        {
          x: 1764719100000,
          y: 161.49999999999997,
        },
        {
          x: 1764719400000,
          y: 169.8,
        },
        {
          x: 1764719700000,
          y: 163.20000000000002,
        },
        {
          x: 1764720000000,
          y: 155,
        },
        {
          x: 1764720300000,
          y: 161.5,
        },
        {
          x: 1764720600000,
          y: 159.59999999999997,
        },
        {
          x: 1764720900000,
          y: 150.3,
        },
        {
          x: 1764721200000,
          y: 155.6,
        },
        {
          x: 1764721500000,
          y: 156.4,
        },
        {
          x: 1764721800000,
          y: 145.79999999999998,
        },
        {
          x: 1764722100000,
          y: 149.4,
        },
        {
          x: 1764722400000,
          y: 151.6,
        },
        {
          x: 1764722700000,
          y: 142,
        },
        {
          x: 1764723000000,
          y: 153.5,
        },
        {
          x: 1764723300000,
          y: 164.29999999999998,
        },
        {
          x: 1764723600000,
          y: 145.29999999999998,
        },
        {
          x: 1764723900000,
          y: 156.8,
        },
        {
          x: 1764724200000,
          y: 144.1,
        },
        {
          x: 1764724500000,
          y: 134.89999999999998,
        },
        {
          x: 1764724800000,
          y: 152.2,
        },
        {
          x: 1764725100000,
          y: 147.8,
        },
        {
          x: 1764725400000,
          y: 148.6,
        },
        {
          x: 1764725700000,
          y: 160,
        },
        {
          x: 1764726000000,
          y: 148.20000000000002,
        },
        {
          x: 1764726300000,
          y: 145.6,
        },
        {
          x: 1764726600000,
          y: 149,
        },
        {
          x: 1764726900000,
          y: 147.1,
        },
        {
          x: 1764727200000,
          y: 141.5,
        },
        {
          x: 1764727500000,
          y: 151.8,
        },
        {
          x: 1764727800000,
          y: 149.1,
        },
        {
          x: 1764728100000,
          y: 139.2,
        },
        {
          x: 1764728400000,
          y: 147.9,
        },
        {
          x: 1764728700000,
          y: 149.5,
        },
        {
          x: 1764729000000,
          y: 137.2,
        },
        {
          x: 1764729300000,
          y: 149.8,
        },
        {
          x: 1764729600000,
          y: 144.6,
        },
        {
          x: 1764729900000,
          y: 149.2,
        },
        {
          x: 1764730200000,
          y: 145.3,
        },
        {
          x: 1764730500000,
          y: 146.9,
        },
        {
          x: 1764730800000,
          y: 147.3,
        },
        {
          x: 1764731100000,
          y: 148.20000000000002,
        },
        {
          x: 1764731400000,
          y: 141.9,
        },
        {
          x: 1764731700000,
          y: 149.5,
        },
        {
          x: 1764732000000,
          y: 151,
        },
        {
          x: 1764732300000,
          y: 161.8,
        },
        {
          x: 1764732600000,
          y: 142.1,
        },
        {
          x: 1764732900000,
          y: 141.70000000000002,
        },
        {
          x: 1764733200000,
          y: 133.8,
        },
        {
          x: 1764733500000,
          y: 133.9,
        },
        {
          x: 1764733800000,
          y: 152.10000000000002,
        },
        {
          x: 1764734100000,
          y: 161.8,
        },
        {
          x: 1764734400000,
          y: 150.3,
        },
        {
          x: 1764734700000,
          y: 160.2,
        },
        {
          x: 1764735000000,
          y: 148.20000000000002,
        },
        {
          x: 1764735300000,
          y: 140.9,
        },
        {
          x: 1764735600000,
          y: 146.7,
        },
        {
          x: 1764735900000,
          y: 156.6,
        },
        {
          x: 1764736200000,
          y: 151.7,
        },
        {
          x: 1764736500000,
          y: 157.4,
        },
        {
          x: 1764736800000,
          y: 155.20000000000002,
        },
        {
          x: 1764737100000,
          y: 155.20000000000002,
        },
        {
          x: 1764737400000,
          y: 145.6,
        },
        {
          x: 1764737700000,
          y: 149.8,
        },
        {
          x: 1764738000000,
          y: 147.3,
        },
        {
          x: 1764738300000,
          y: 153.3,
        },
        {
          x: 1764738600000,
          y: 142.6,
        },
        {
          x: 1764738900000,
          y: 141.7,
        },
        {
          x: 1764739200000,
          y: 166.20000000000002,
        },
        {
          x: 1764739500000,
          y: 163.9,
        },
        {
          x: 1764739800000,
          y: 143.20000000000002,
        },
        {
          x: 1764740100000,
          y: 148.9,
        },
        {
          x: 1764740400000,
          y: 155.6,
        },
        {
          x: 1764740700000,
          y: 153.2,
        },
        {
          x: 1764741000000,
          y: 182.4,
        },
        {
          x: 1764741300000,
          y: 181,
        },
        {
          x: 1764741600000,
          y: 170.4,
        },
        {
          x: 1764741900000,
          y: 194.6,
        },
        {
          x: 1764742200000,
          y: 213.4,
        },
        {
          x: 1764742500000,
          y: 210.09999999999997,
        },
        {
          x: 1764742800000,
          y: 212.70000000000002,
        },
        {
          x: 1764743100000,
          y: 221.2,
        },
        {
          x: 1764743400000,
          y: 177.29999999999998,
        },
        {
          x: 1764743700000,
          y: 218,
        },
        {
          x: 1764744000000,
          y: 238.2,
        },
        {
          x: 1764744300000,
          y: 210.90000000000003,
        },
        {
          x: 1764744600000,
          y: 220,
        },
        {
          x: 1764744900000,
          y: 256.8,
        },
        {
          x: 1764745200000,
          y: 263.9,
        },
        {
          x: 1764745500000,
          y: 317.50000000000006,
        },
        {
          x: 1764745800000,
          y: 323.3,
        },
        {
          x: 1764746100000,
          y: 318.6,
        },
        {
          x: 1764746400000,
          y: 331.3,
        },
        {
          x: 1764746700000,
          y: 323,
        },
        {
          x: 1764747000000,
          y: 308.70000000000005,
        },
        {
          x: 1764747300000,
          y: 351.5,
        },
        {
          x: 1764747600000,
          y: 359.59999999999997,
        },
        {
          x: 1764747900000,
          y: 357.8,
        },
        {
          x: 1764748200000,
          y: 382.9,
        },
        {
          x: 1764748500000,
          y: 392.29999999999995,
        },
        {
          x: 1764748800000,
          y: 327.2,
        },
        {
          x: 1764749100000,
          y: 369.6,
        },
        {
          x: 1764749400000,
          y: 367,
        },
        {
          x: 1764749700000,
          y: 335.6,
        },
        {
          x: 1764750000000,
          y: 365.7,
        },
        {
          x: 1764750300000,
          y: 389.4,
        },
        {
          x: 1764750600000,
          y: 357.4,
        },
        {
          x: 1764750900000,
          y: 359.2,
        },
        {
          x: 1764751200000,
          y: 393.99999999999994,
        },
        {
          x: 1764751500000,
          y: 344.49999999999994,
        },
        {
          x: 1764751800000,
          y: 362.3,
        },
        {
          x: 1764752100000,
          y: 369.8,
        },
        {
          x: 1764752400000,
          y: 340.70000000000005,
        },
        {
          x: 1764752700000,
          y: 361.1,
        },
        {
          x: 1764753000000,
          y: 359.09999999999997,
        },
        {
          x: 1764753300000,
          y: 344.29999999999995,
        },
        {
          x: 1764753600000,
          y: 369.8,
        },
        {
          x: 1764753900000,
          y: 392.4,
        },
        {
          x: 1764754200000,
          y: 366.7,
        },
        {
          x: 1764754500000,
          y: 398.70000000000005,
        },
        {
          x: 1764754800000,
          y: 382.7,
        },
        {
          x: 1764755100000,
          y: 354,
        },
        {
          x: 1764755400000,
          y: 352.90000000000003,
        },
        {
          x: 1764755700000,
          y: 363.1,
        },
        {
          x: 1764756000000,
          y: 359,
        },
        {
          x: 1764756300000,
          y: 357.79999999999995,
        },
        {
          x: 1764756600000,
          y: 351.70000000000005,
        },
        {
          x: 1764756900000,
          y: 335.5,
        },
        {
          x: 1764757200000,
          y: 360.40000000000003,
        },
        {
          x: 1764757500000,
          y: 358.50000000000006,
        },
        {
          x: 1764757800000,
          y: 364.3,
        },
        {
          x: 1764758100000,
          y: 376.1,
        },
        {
          x: 1764758400000,
          y: 404.2,
        },
        {
          x: 1764758700000,
          y: 383.5,
        },
        {
          x: 1764759000000,
          y: 367.1,
        },
        {
          x: 1764759300000,
          y: 376.6,
        },
        {
          x: 1764759600000,
          y: 391.8,
        },
        {
          x: 1764759900000,
          y: 393.40000000000003,
        },
        {
          x: 1764760200000,
          y: 375.50000000000006,
        },
        {
          x: 1764760500000,
          y: 352.3,
        },
        {
          x: 1764760800000,
          y: 383.1,
        },
        {
          x: 1764761100000,
          y: 386.6,
        },
        {
          x: 1764761400000,
          y: 364.50000000000006,
        },
        {
          x: 1764761700000,
          y: 379.8,
        },
        {
          x: 1764762000000,
          y: 396.9,
        },
        {
          x: 1764762300000,
          y: 362.2,
        },
        {
          x: 1764762600000,
          y: 347.59999999999997,
        },
        {
          x: 1764762900000,
          y: 376.79999999999995,
        },
        {
          x: 1764763200000,
          y: 371.3999999999999,
        },
        {
          x: 1764763500000,
          y: 392.9000000000001,
        },
        {
          x: 1764763800000,
          y: 385.70000000000005,
        },
        {
          x: 1764764100000,
          y: 340.9,
        },
        {
          x: 1764764400000,
          y: 374.4,
        },
        {
          x: 1764764700000,
          y: 392.4,
        },
        {
          x: 1764765000000,
          y: 352.3,
        },
        {
          x: 1764765300000,
          y: 413.70000000000005,
        },
        {
          x: 1764765600000,
          y: 396.40000000000003,
        },
        {
          x: 1764765900000,
          y: 329.9,
        },
        {
          x: 1764766200000,
          y: 337.3,
        },
        {
          x: 1764766500000,
          y: 350.09999999999997,
        },
        {
          x: 1764766800000,
          y: 336.40000000000003,
        },
        {
          x: 1764767100000,
          y: 335.5,
        },
        {
          x: 1764767400000,
          y: 348.2,
        },
        {
          x: 1764767700000,
          y: 321.09999999999997,
        },
        {
          x: 1764768000000,
          y: 330.79999999999995,
        },
        {
          x: 1764768300000,
          y: 326.9,
        },
        {
          x: 1764768600000,
          y: 328.5,
        },
        {
          x: 1764768900000,
          y: 346.2,
        },
        {
          x: 1764769200000,
          y: 343.5,
        },
        {
          x: 1764769500000,
          y: 351.5999999999999,
        },
        {
          x: 1764769800000,
          y: 357.20000000000005,
        },
      ],
    },
    {
      field: 'consumption',
      points: [
        {
          x: 1764684000000,
          y: 253.10000000000002,
        },
        {
          x: 1764684300000,
          y: 262.2,
        },
        {
          x: 1764684600000,
          y: 264.5,
        },
        {
          x: 1764684900000,
          y: 230.3,
        },
        {
          x: 1764685200000,
          y: 239.4,
        },
        {
          x: 1764685500000,
          y: 242.10000000000002,
        },
        {
          x: 1764685800000,
          y: 234.29999999999998,
        },
        {
          x: 1764686100000,
          y: 247.19999999999996,
        },
        {
          x: 1764686400000,
          y: 239,
        },
        {
          x: 1764686700000,
          y: 194.4,
        },
        {
          x: 1764687000000,
          y: 214.1,
        },
        {
          x: 1764687300000,
          y: 219.20000000000002,
        },
        {
          x: 1764687600000,
          y: 201.99999999999997,
        },
        {
          x: 1764687900000,
          y: 217.4,
        },
        {
          x: 1764688200000,
          y: 236.2,
        },
        {
          x: 1764688500000,
          y: 226.10000000000002,
        },
        {
          x: 1764688800000,
          y: 231.9,
        },
        {
          x: 1764689100000,
          y: 243.5,
        },
        {
          x: 1764689400000,
          y: 222.8,
        },
        {
          x: 1764689700000,
          y: 234.6,
        },
        {
          x: 1764690000000,
          y: 239.40000000000003,
        },
        {
          x: 1764690300000,
          y: 250.3,
        },
        {
          x: 1764690600000,
          y: 263.8,
        },
        {
          x: 1764690900000,
          y: 267.90000000000003,
        },
        {
          x: 1764691200000,
          y: 246.20000000000002,
        },
        {
          x: 1764691500000,
          y: 261.1,
        },
        {
          x: 1764691800000,
          y: 284.29999999999995,
        },
        {
          x: 1764692100000,
          y: 297.7,
        },
        {
          x: 1764692400000,
          y: 290.7,
        },
        {
          x: 1764692700000,
          y: 286.5,
        },
        {
          x: 1764693000000,
          y: 286,
        },
        {
          x: 1764693300000,
          y: 323.3,
        },
        {
          x: 1764693600000,
          y: 350.7,
        },
        {
          x: 1764693900000,
          y: 322.5,
        },
        {
          x: 1764694200000,
          y: 319.8,
        },
        {
          x: 1764694500000,
          y: 302.6,
        },
        {
          x: 1764694800000,
          y: 289.7,
        },
        {
          x: 1764695100000,
          y: 320.40000000000003,
        },
        {
          x: 1764695400000,
          y: 314.3,
        },
        {
          x: 1764695700000,
          y: 290.2,
        },
        {
          x: 1764696000000,
          y: 304.6,
        },
        {
          x: 1764696300000,
          y: 330.5,
        },
        {
          x: 1764696600000,
          y: 292.8,
        },
        {
          x: 1764696900000,
          y: 324,
        },
        {
          x: 1764697200000,
          y: 321.6,
        },
        {
          x: 1764697500000,
          y: 305.8,
        },
        {
          x: 1764697800000,
          y: 301.8,
        },
        {
          x: 1764698100000,
          y: 289.4,
        },
        {
          x: 1764698400000,
          y: 288.6,
        },
        {
          x: 1764698700000,
          y: 285.4,
        },
        {
          x: 1764699000000,
          y: 286.6,
        },
        {
          x: 1764699300000,
          y: 273.2,
        },
        {
          x: 1764699600000,
          y: 312.6000000000001,
        },
        {
          x: 1764699900000,
          y: 293.6,
        },
        {
          x: 1764700200000,
          y: 278.49999999999994,
        },
        {
          x: 1764700500000,
          y: 322.9,
        },
        {
          x: 1764700800000,
          y: 308.4,
        },
        {
          x: 1764701100000,
          y: 268.90000000000003,
        },
        {
          x: 1764701400000,
          y: 346.9,
        },
        {
          x: 1764701700000,
          y: 323.5,
        },
        {
          x: 1764702000000,
          y: 286.1,
        },
        {
          x: 1764702300000,
          y: 286.8,
        },
        {
          x: 1764702600000,
          y: 301.5,
        },
        {
          x: 1764702900000,
          y: 302,
        },
        {
          x: 1764703200000,
          y: 325.6,
        },
        {
          x: 1764703500000,
          y: 307.5,
        },
        {
          x: 1764703800000,
          y: 275,
        },
        {
          x: 1764704100000,
          y: 287.6,
        },
        {
          x: 1764704400000,
          y: 271.00000000000006,
        },
        {
          x: 1764704700000,
          y: 265.59999999999997,
        },
        {
          x: 1764705000000,
          y: 264.90000000000003,
        },
        {
          x: 1764705300000,
          y: 272.8,
        },
        {
          x: 1764705600000,
          y: 254,
        },
        {
          x: 1764705900000,
          y: 258,
        },
        {
          x: 1764706200000,
          y: 244.70000000000005,
        },
        {
          x: 1764706500000,
          y: 233.7,
        },
        {
          x: 1764706800000,
          y: 229.10000000000002,
        },
        {
          x: 1764707100000,
          y: 244.6,
        },
        {
          x: 1764707400000,
          y: 223.10000000000002,
        },
        {
          x: 1764707700000,
          y: 219.50000000000003,
        },
        {
          x: 1764708000000,
          y: 237.5,
        },
        {
          x: 1764708300000,
          y: 227.79999999999998,
        },
        {
          x: 1764708600000,
          y: 213.60000000000002,
        },
        {
          x: 1764708900000,
          y: 198.20000000000002,
        },
        {
          x: 1764709200000,
          y: 183.9,
        },
        {
          x: 1764709500000,
          y: 192.9,
        },
        {
          x: 1764709800000,
          y: 194.20000000000002,
        },
        {
          x: 1764710100000,
          y: 168.20000000000002,
        },
        {
          x: 1764710400000,
          y: 201.3,
        },
        {
          x: 1764710700000,
          y: 191.4,
        },
        {
          x: 1764711000000,
          y: 165.1,
        },
        {
          x: 1764711300000,
          y: 174.7,
        },
        {
          x: 1764711600000,
          y: 161.6,
        },
        {
          x: 1764711900000,
          y: 157,
        },
        {
          x: 1764712200000,
          y: 157.4,
        },
        {
          x: 1764712500000,
          y: 150.39999999999998,
        },
        {
          x: 1764712800000,
          y: 145.4,
        },
        {
          x: 1764713100000,
          y: 152,
        },
        {
          x: 1764713400000,
          y: 152.60000000000002,
        },
        {
          x: 1764713700000,
          y: 136.1,
        },
        {
          x: 1764714000000,
          y: 137.7,
        },
        {
          x: 1764714300000,
          y: 148.1,
        },
        {
          x: 1764714600000,
          y: 147.20000000000002,
        },
        {
          x: 1764714900000,
          y: 162.8,
        },
        {
          x: 1764715200000,
          y: 169.6,
        },
        {
          x: 1764715500000,
          y: 154.9,
        },
        {
          x: 1764715800000,
          y: 153.79999999999998,
        },
        {
          x: 1764716100000,
          y: 151.2,
        },
        {
          x: 1764716400000,
          y: 146.9,
        },
        {
          x: 1764717000000,
          y: 144.8,
        },
        {
          x: 1764717300000,
          y: 136.5,
        },
        {
          x: 1764717600000,
          y: 143.6,
        },
        {
          x: 1764717900000,
          y: 137.4,
        },
        {
          x: 1764718200000,
          y: 130.20000000000002,
        },
        {
          x: 1764718500000,
          y: 135.3,
        },
        {
          x: 1764718800000,
          y: 130.6,
        },
        {
          x: 1764719100000,
          y: 126.5,
        },
        {
          x: 1764719400000,
          y: 131.9,
        },
        {
          x: 1764719700000,
          y: 122.6,
        },
        {
          x: 1764720000000,
          y: 116.99999999999999,
        },
        {
          x: 1764720300000,
          y: 121.80000000000001,
        },
        {
          x: 1764720600000,
          y: 119.1,
        },
        {
          x: 1764720900000,
          y: 111.49999999999999,
        },
        {
          x: 1764721200000,
          y: 120.1,
        },
        {
          x: 1764721500000,
          y: 126.30000000000001,
        },
        {
          x: 1764721800000,
          y: 115.1,
        },
        {
          x: 1764722100000,
          y: 121.00000000000001,
        },
        {
          x: 1764722400000,
          y: 128.6,
        },
        {
          x: 1764722700000,
          y: 118.10000000000001,
        },
        {
          x: 1764723000000,
          y: 122.09999999999998,
        },
        {
          x: 1764723300000,
          y: 121.7,
        },
        {
          x: 1764723600000,
          y: 111,
        },
        {
          x: 1764723900000,
          y: 114.10000000000002,
        },
        {
          x: 1764724200000,
          y: 115.39999999999999,
        },
        {
          x: 1764724500000,
          y: 110.7,
        },
        {
          x: 1764724800000,
          y: 126.2,
        },
        {
          x: 1764725100000,
          y: 121.4,
        },
        {
          x: 1764725400000,
          y: 115.1,
        },
        {
          x: 1764725700000,
          y: 123.3,
        },
        {
          x: 1764726000000,
          y: 113.3,
        },
        {
          x: 1764726300000,
          y: 114.69999999999999,
        },
        {
          x: 1764726600000,
          y: 120.50000000000001,
        },
        {
          x: 1764726900000,
          y: 117.80000000000001,
        },
        {
          x: 1764727200000,
          y: 110.5,
        },
        {
          x: 1764727500000,
          y: 121.9,
        },
        {
          x: 1764727800000,
          y: 119.8,
        },
        {
          x: 1764728100000,
          y: 118.30000000000001,
        },
        {
          x: 1764728400000,
          y: 122.50000000000001,
        },
        {
          x: 1764728700000,
          y: 112.9,
        },
        {
          x: 1764729000000,
          y: 102.1,
        },
        {
          x: 1764729300000,
          y: 117.50000000000001,
        },
        {
          x: 1764729600000,
          y: 116.4,
        },
        {
          x: 1764729900000,
          y: 113,
        },
        {
          x: 1764730200000,
          y: 116.4,
        },
        {
          x: 1764730500000,
          y: 113.49999999999999,
        },
        {
          x: 1764730800000,
          y: 112.30000000000001,
        },
        {
          x: 1764731100000,
          y: 121.2,
        },
        {
          x: 1764731400000,
          y: 115.69999999999997,
        },
        {
          x: 1764731700000,
          y: 110.6,
        },
        {
          x: 1764732000000,
          y: 123.10000000000001,
        },
        {
          x: 1764732300000,
          y: 122.19999999999999,
        },
        {
          x: 1764732600000,
          y: 113.3,
        },
        {
          x: 1764732900000,
          y: 117.30000000000001,
        },
        {
          x: 1764733200000,
          y: 115,
        },
        {
          x: 1764733500000,
          y: 107.89999999999999,
        },
        {
          x: 1764733800000,
          y: 121.89999999999999,
        },
        {
          x: 1764734100000,
          y: 118.29999999999998,
        },
        {
          x: 1764734400000,
          y: 108.5,
        },
        {
          x: 1764734700000,
          y: 115.19999999999999,
        },
        {
          x: 1764735000000,
          y: 121.80000000000001,
        },
        {
          x: 1764735300000,
          y: 108.19999999999999,
        },
        {
          x: 1764735600000,
          y: 115.70000000000002,
        },
        {
          x: 1764735900000,
          y: 127.30000000000001,
        },
        {
          x: 1764736200000,
          y: 119.19999999999999,
        },
        {
          x: 1764736500000,
          y: 124.1,
        },
        {
          x: 1764736800000,
          y: 114.5,
        },
        {
          x: 1764737100000,
          y: 113.7,
        },
        {
          x: 1764737400000,
          y: 110.99999999999999,
        },
        {
          x: 1764737700000,
          y: 111.7,
        },
        {
          x: 1764738000000,
          y: 106.99999999999999,
        },
        {
          x: 1764738300000,
          y: 114.60000000000001,
        },
        {
          x: 1764738600000,
          y: 111.60000000000001,
        },
        {
          x: 1764738900000,
          y: 107.69999999999999,
        },
        {
          x: 1764739200000,
          y: 121.8,
        },
        {
          x: 1764739500000,
          y: 118.5,
        },
        {
          x: 1764739800000,
          y: 105.19999999999999,
        },
        {
          x: 1764740100000,
          y: 115.49999999999999,
        },
        {
          x: 1764740400000,
          y: 125.5,
        },
        {
          x: 1764740700000,
          y: 129.70000000000002,
        },
        {
          x: 1764741000000,
          y: 148.50000000000003,
        },
        {
          x: 1764741300000,
          y: 140.79999999999998,
        },
        {
          x: 1764741600000,
          y: 147.6,
        },
        {
          x: 1764741900000,
          y: 169.90000000000003,
        },
        {
          x: 1764742200000,
          y: 181.80000000000004,
        },
        {
          x: 1764742500000,
          y: 173.4,
        },
        {
          x: 1764742800000,
          y: 204.99999999999997,
        },
        {
          x: 1764743100000,
          y: 227.29999999999998,
        },
        {
          x: 1764743400000,
          y: 176.3,
        },
        {
          x: 1764743700000,
          y: 191.6,
        },
        {
          x: 1764744000000,
          y: 216.89999999999998,
        },
        {
          x: 1764744300000,
          y: 190,
        },
        {
          x: 1764744600000,
          y: 206.9,
        },
        {
          x: 1764744900000,
          y: 232.29999999999998,
        },
        {
          x: 1764745200000,
          y: 229.6,
        },
        {
          x: 1764745500000,
          y: 256.40000000000003,
        },
        {
          x: 1764745800000,
          y: 277.2,
        },
        {
          x: 1764746100000,
          y: 257.29999999999995,
        },
        {
          x: 1764746400000,
          y: 272.3,
        },
        {
          x: 1764746700000,
          y: 266.50000000000006,
        },
        {
          x: 1764747000000,
          y: 269.8,
        },
        {
          x: 1764747300000,
          y: 306.5,
        },
        {
          x: 1764747600000,
          y: 298.7,
        },
        {
          x: 1764747900000,
          y: 261.79999999999995,
        },
        {
          x: 1764748200000,
          y: 289,
        },
        {
          x: 1764748500000,
          y: 309.2,
        },
        {
          x: 1764748800000,
          y: 247.6,
        },
        {
          x: 1764749100000,
          y: 273.8,
        },
        {
          x: 1764749400000,
          y: 304.09999999999997,
        },
        {
          x: 1764749700000,
          y: 274.7,
        },
        {
          x: 1764750000000,
          y: 298.19999999999993,
        },
        {
          x: 1764750300000,
          y: 332.4,
        },
        {
          x: 1764750600000,
          y: 271.29999999999995,
        },
        {
          x: 1764750900000,
          y: 280.8,
        },
        {
          x: 1764751200000,
          y: 312.8,
        },
        {
          x: 1764751500000,
          y: 283.79999999999995,
        },
        {
          x: 1764751800000,
          y: 330.90000000000003,
        },
        {
          x: 1764752100000,
          y: 347.79999999999995,
        },
        {
          x: 1764752400000,
          y: 295.5,
        },
        {
          x: 1764752700000,
          y: 308.90000000000003,
        },
        {
          x: 1764753000000,
          y: 284.5,
        },
        {
          x: 1764753300000,
          y: 273.9,
        },
        {
          x: 1764753600000,
          y: 277.9,
        },
        {
          x: 1764753900000,
          y: 297.99999999999994,
        },
        {
          x: 1764754200000,
          y: 248.70000000000002,
        },
        {
          x: 1764754500000,
          y: 275.79999999999995,
        },
        {
          x: 1764754800000,
          y: 267.2,
        },
        {
          x: 1764755100000,
          y: 239.7,
        },
        {
          x: 1764755400000,
          y: 270.59999999999997,
        },
        {
          x: 1764755700000,
          y: 280.9,
        },
        {
          x: 1764756000000,
          y: 269.7,
        },
        {
          x: 1764756300000,
          y: 291.90000000000003,
        },
        {
          x: 1764756600000,
          y: 312.00000000000006,
        },
        {
          x: 1764756900000,
          y: 284.5,
        },
        {
          x: 1764757200000,
          y: 303,
        },
        {
          x: 1764757500000,
          y: 303.3,
        },
        {
          x: 1764757800000,
          y: 288.6000000000001,
        },
        {
          x: 1764758100000,
          y: 280.7,
        },
        {
          x: 1764758400000,
          y: 295.8,
        },
        {
          x: 1764758700000,
          y: 290.69999999999993,
        },
        {
          x: 1764759000000,
          y: 287.00000000000006,
        },
        {
          x: 1764759300000,
          y: 279.7,
        },
        {
          x: 1764759600000,
          y: 264.1,
        },
        {
          x: 1764759900000,
          y: 287.5,
        },
        {
          x: 1764760200000,
          y: 300.2,
        },
        {
          x: 1764760500000,
          y: 273.09999999999997,
        },
        {
          x: 1764760800000,
          y: 316.90000000000003,
        },
        {
          x: 1764761100000,
          y: 295.2,
        },
        {
          x: 1764761400000,
          y: 247.2,
        },
        {
          x: 1764761700000,
          y: 286.20000000000005,
        },
        {
          x: 1764762000000,
          y: 307.6,
        },
        {
          x: 1764762300000,
          y: 269.7,
        },
        {
          x: 1764762600000,
          y: 291.4,
        },
        {
          x: 1764762900000,
          y: 282.3,
        },
        {
          x: 1764763200000,
          y: 268.1,
        },
        {
          x: 1764763500000,
          y: 286.50000000000006,
        },
        {
          x: 1764763800000,
          y: 278.20000000000005,
        },
        {
          x: 1764764100000,
          y: 250.3,
        },
        {
          x: 1764764400000,
          y: 288.4,
        },
        {
          x: 1764764700000,
          y: 308.6,
        },
        {
          x: 1764765000000,
          y: 267.8,
        },
        {
          x: 1764765300000,
          y: 296.9,
        },
        {
          x: 1764765600000,
          y: 302.00000000000006,
        },
        {
          x: 1764765900000,
          y: 254.10000000000002,
        },
        {
          x: 1764766200000,
          y: 287.09999999999997,
        },
        {
          x: 1764766500000,
          y: 298.20000000000005,
        },
        {
          x: 1764766800000,
          y: 275.8,
        },
        {
          x: 1764767100000,
          y: 312.40000000000003,
        },
        {
          x: 1764767400000,
          y: 281.40000000000003,
        },
        {
          x: 1764767700000,
          y: 256.49999999999994,
        },
        {
          x: 1764768000000,
          y: 273.4,
        },
        {
          x: 1764768300000,
          y: 270.1,
        },
        {
          x: 1764768600000,
          y: 256.2,
        },
        {
          x: 1764768900000,
          y: 271.29999999999995,
        },
        {
          x: 1764769200000,
          y: 263.9,
        },
        {
          x: 1764769500000,
          y: 240,
        },
        {
          x: 1764769800000,
          y: 276.6,
        },
      ],
    },
    {
      field: 'losses',
      points: [
        {
          x: 1764684000000,
          y: 235.8,
        },
        {
          x: 1764684300000,
          y: 272.09999999999997,
        },
        {
          x: 1764684600000,
          y: 283.40000000000003,
        },
        {
          x: 1764684900000,
          y: 235.70000000000005,
        },
        {
          x: 1764685200000,
          y: 292.90000000000003,
        },
        {
          x: 1764685500000,
          y: 289.3,
        },
        {
          x: 1764685800000,
          y: 250.8,
        },
        {
          x: 1764686100000,
          y: 308.09999999999997,
        },
        {
          x: 1764686400000,
          y: 312.09999999999997,
        },
        {
          x: 1764686700000,
          y: 246.39999999999998,
        },
        {
          x: 1764687000000,
          y: 288.79999999999995,
        },
        {
          x: 1764687300000,
          y: 311.4,
        },
        {
          x: 1764687600000,
          y: 260,
        },
        {
          x: 1764687900000,
          y: 304.5,
        },
        {
          x: 1764688200000,
          y: 298.7,
        },
        {
          x: 1764688500000,
          y: 263.7,
        },
        {
          x: 1764688800000,
          y: 298.70000000000005,
        },
        {
          x: 1764689100000,
          y: 307.9,
        },
        {
          x: 1764689400000,
          y: 275.9,
        },
        {
          x: 1764689700000,
          y: 293.40000000000003,
        },
        {
          x: 1764690000000,
          y: 295.20000000000005,
        },
        {
          x: 1764690300000,
          y: 290.20000000000005,
        },
        {
          x: 1764690600000,
          y: 321.1,
        },
        {
          x: 1764690900000,
          y: 323.3,
        },
        {
          x: 1764691200000,
          y: 280.5,
        },
        {
          x: 1764691500000,
          y: 338,
        },
        {
          x: 1764691800000,
          y: 356,
        },
        {
          x: 1764692100000,
          y: 313.6,
        },
        {
          x: 1764692400000,
          y: 342.90000000000003,
        },
        {
          x: 1764692700000,
          y: 361.90000000000003,
        },
        {
          x: 1764693000000,
          y: 349.8,
        },
        {
          x: 1764693300000,
          y: 373.70000000000005,
        },
        {
          x: 1764693600000,
          y: 396.7,
        },
        {
          x: 1764693900000,
          y: 361.2,
        },
        {
          x: 1764694200000,
          y: 385.4,
        },
        {
          x: 1764694500000,
          y: 360.50000000000006,
        },
        {
          x: 1764694800000,
          y: 328,
        },
        {
          x: 1764695100000,
          y: 351.1,
        },
        {
          x: 1764695400000,
          y: 362.90000000000003,
        },
        {
          x: 1764695700000,
          y: 319.3,
        },
        {
          x: 1764696000000,
          y: 371.9,
        },
        {
          x: 1764696300000,
          y: 410.3,
        },
        {
          x: 1764696600000,
          y: 354.09999999999997,
        },
        {
          x: 1764696900000,
          y: 434.6,
        },
        {
          x: 1764697200000,
          y: 423.7,
        },
        {
          x: 1764697500000,
          y: 363.7,
        },
        {
          x: 1764697800000,
          y: 428.09999999999997,
        },
        {
          x: 1764698100000,
          y: 426.3,
        },
        {
          x: 1764698400000,
          y: 424.4,
        },
        {
          x: 1764698700000,
          y: 452.3,
        },
        {
          x: 1764699000000,
          y: 421.29999999999995,
        },
        {
          x: 1764699300000,
          y: 377.3,
        },
        {
          x: 1764699600000,
          y: 415.6,
        },
        {
          x: 1764699900000,
          y: 416.79999999999995,
        },
        {
          x: 1764700200000,
          y: 402.20000000000005,
        },
        {
          x: 1764700500000,
          y: 439.6,
        },
        {
          x: 1764700800000,
          y: 401.99999999999994,
        },
        {
          x: 1764701100000,
          y: 344.09999999999997,
        },
        {
          x: 1764701400000,
          y: 387.5,
        },
        {
          x: 1764701700000,
          y: 360.5,
        },
        {
          x: 1764702000000,
          y: 333,
        },
        {
          x: 1764702300000,
          y: 356.4,
        },
        {
          x: 1764702600000,
          y: 369.1,
        },
        {
          x: 1764702900000,
          y: 326.80000000000007,
        },
        {
          x: 1764703200000,
          y: 368.5,
        },
        {
          x: 1764703500000,
          y: 363.4,
        },
        {
          x: 1764703800000,
          y: 317.8,
        },
        {
          x: 1764704100000,
          y: 348.40000000000003,
        },
        {
          x: 1764704400000,
          y: 348.29999999999995,
        },
        {
          x: 1764704700000,
          y: 282.09999999999997,
        },
        {
          x: 1764705000000,
          y: 309.9,
        },
        {
          x: 1764705300000,
          y: 306.99999999999994,
        },
        {
          x: 1764705600000,
          y: 281.4,
        },
        {
          x: 1764705900000,
          y: 298.6,
        },
        {
          x: 1764706200000,
          y: 309.79999999999995,
        },
        {
          x: 1764706500000,
          y: 290.40000000000003,
        },
        {
          x: 1764706800000,
          y: 290.3,
        },
        {
          x: 1764707100000,
          y: 290.7,
        },
        {
          x: 1764707400000,
          y: 244.3,
        },
        {
          x: 1764707700000,
          y: 267.20000000000005,
        },
        {
          x: 1764708000000,
          y: 274.2,
        },
        {
          x: 1764708300000,
          y: 241.89999999999998,
        },
        {
          x: 1764708600000,
          y: 276.7,
        },
        {
          x: 1764708900000,
          y: 282.3,
        },
        {
          x: 1764709200000,
          y: 238.49999999999997,
        },
        {
          x: 1764709500000,
          y: 242.79999999999998,
        },
        {
          x: 1764709800000,
          y: 237.3,
        },
        {
          x: 1764710100000,
          y: 210.2,
        },
        {
          x: 1764710400000,
          y: 215.4,
        },
        {
          x: 1764710700000,
          y: 229.4,
        },
        {
          x: 1764711000000,
          y: 211.89999999999998,
        },
        {
          x: 1764711300000,
          y: 231.90000000000003,
        },
        {
          x: 1764711600000,
          y: 236.6,
        },
        {
          x: 1764711900000,
          y: 211.20000000000002,
        },
        {
          x: 1764712200000,
          y: 236.8,
        },
        {
          x: 1764712500000,
          y: 216.20000000000002,
        },
        {
          x: 1764712800000,
          y: 178.6,
        },
        {
          x: 1764713100000,
          y: 217,
        },
        {
          x: 1764713400000,
          y: 224.20000000000002,
        },
        {
          x: 1764713700000,
          y: 175.60000000000002,
        },
        {
          x: 1764714000000,
          y: 220.9,
        },
        {
          x: 1764714300000,
          y: 208.5,
        },
        {
          x: 1764714600000,
          y: 179.79999999999998,
        },
        {
          x: 1764714900000,
          y: 192.9,
        },
        {
          x: 1764715200000,
          y: 214.70000000000002,
        },
        {
          x: 1764715500000,
          y: 174.6,
        },
        {
          x: 1764715800000,
          y: 189.89999999999998,
        },
        {
          x: 1764716100000,
          y: 194,
        },
        {
          x: 1764716400000,
          y: 185.7,
        },
        {
          x: 1764717000000,
          y: 205.9,
        },
        {
          x: 1764717300000,
          y: 173.50000000000003,
        },
        {
          x: 1764717600000,
          y: 212.9,
        },
        {
          x: 1764717900000,
          y: 192.4,
        },
        {
          x: 1764718200000,
          y: 167.29999999999998,
        },
        {
          x: 1764718500000,
          y: 188.8,
        },
        {
          x: 1764718800000,
          y: 193.2,
        },
        {
          x: 1764719100000,
          y: 175.89999999999998,
        },
        {
          x: 1764719400000,
          y: 183.99999999999997,
        },
        {
          x: 1764719700000,
          y: 176.1,
        },
        {
          x: 1764720000000,
          y: 143.4,
        },
        {
          x: 1764720300000,
          y: 159.9,
        },
        {
          x: 1764720600000,
          y: 169.20000000000002,
        },
        {
          x: 1764720900000,
          y: 148.7,
        },
        {
          x: 1764721200000,
          y: 153.4,
        },
        {
          x: 1764721500000,
          y: 150.9,
        },
        {
          x: 1764721800000,
          y: 136.4,
        },
        {
          x: 1764722100000,
          y: 138.1,
        },
        {
          x: 1764722400000,
          y: 141.4,
        },
        {
          x: 1764722700000,
          y: 137.7,
        },
        {
          x: 1764723000000,
          y: 159.7,
        },
        {
          x: 1764723300000,
          y: 160.5,
        },
        {
          x: 1764723600000,
          y: 140.9,
        },
        {
          x: 1764723900000,
          y: 137.20000000000002,
        },
        {
          x: 1764724200000,
          y: 132.8,
        },
        {
          x: 1764724500000,
          y: 124.89999999999999,
        },
        {
          x: 1764724800000,
          y: 144.9,
        },
        {
          x: 1764725100000,
          y: 139.9,
        },
        {
          x: 1764725400000,
          y: 134,
        },
        {
          x: 1764725700000,
          y: 150.4,
        },
        {
          x: 1764726000000,
          y: 143.70000000000002,
        },
        {
          x: 1764726300000,
          y: 129.6,
        },
        {
          x: 1764726600000,
          y: 135.7,
        },
        {
          x: 1764726900000,
          y: 135.29999999999998,
        },
        {
          x: 1764727200000,
          y: 125.1,
        },
        {
          x: 1764727500000,
          y: 147.39999999999998,
        },
        {
          x: 1764727800000,
          y: 148.6,
        },
        {
          x: 1764728100000,
          y: 127.09999999999998,
        },
        {
          x: 1764728400000,
          y: 143.8,
        },
        {
          x: 1764728700000,
          y: 140.4,
        },
        {
          x: 1764729000000,
          y: 120.9,
        },
        {
          x: 1764729300000,
          y: 141.10000000000002,
        },
        {
          x: 1764729600000,
          y: 135.2,
        },
        {
          x: 1764729900000,
          y: 134.2,
        },
        {
          x: 1764730200000,
          y: 147.5,
        },
        {
          x: 1764730500000,
          y: 154.8,
        },
        {
          x: 1764730800000,
          y: 135.2,
        },
        {
          x: 1764731100000,
          y: 157.8,
        },
        {
          x: 1764731400000,
          y: 145.60000000000002,
        },
        {
          x: 1764731700000,
          y: 129.9,
        },
        {
          x: 1764732000000,
          y: 145.50000000000003,
        },
        {
          x: 1764732300000,
          y: 142.4,
        },
        {
          x: 1764732600000,
          y: 124,
        },
        {
          x: 1764732900000,
          y: 135.60000000000002,
        },
        {
          x: 1764733200000,
          y: 137,
        },
        {
          x: 1764733500000,
          y: 121.39999999999999,
        },
        {
          x: 1764733800000,
          y: 147.10000000000002,
        },
        {
          x: 1764734100000,
          y: 149.3,
        },
        {
          x: 1764734400000,
          y: 125.00000000000001,
        },
        {
          x: 1764734700000,
          y: 154.1,
        },
        {
          x: 1764735000000,
          y: 158.2,
        },
        {
          x: 1764735300000,
          y: 134.70000000000002,
        },
        {
          x: 1764735600000,
          y: 153.3,
        },
        {
          x: 1764735900000,
          y: 153.49999999999997,
        },
        {
          x: 1764736200000,
          y: 144.5,
        },
        {
          x: 1764736500000,
          y: 159.20000000000002,
        },
        {
          x: 1764736800000,
          y: 157.59999999999997,
        },
        {
          x: 1764737100000,
          y: 146.50000000000003,
        },
        {
          x: 1764737400000,
          y: 170.9,
        },
        {
          x: 1764737700000,
          y: 186.39999999999998,
        },
        {
          x: 1764738000000,
          y: 166,
        },
        {
          x: 1764738300000,
          y: 187.4,
        },
        {
          x: 1764738600000,
          y: 188.3,
        },
        {
          x: 1764738900000,
          y: 158.60000000000002,
        },
        {
          x: 1764739200000,
          y: 174.49999999999997,
        },
        {
          x: 1764739500000,
          y: 170.49999999999997,
        },
        {
          x: 1764739800000,
          y: 161.20000000000002,
        },
        {
          x: 1764740100000,
          y: 188,
        },
        {
          x: 1764740400000,
          y: 190.7,
        },
        {
          x: 1764740700000,
          y: 163.29999999999998,
        },
        {
          x: 1764741000000,
          y: 172.4,
        },
        {
          x: 1764741300000,
          y: 187.2,
        },
        {
          x: 1764741600000,
          y: 208.2,
        },
        {
          x: 1764741900000,
          y: 233.1,
        },
        {
          x: 1764742200000,
          y: 249.8,
        },
        {
          x: 1764742500000,
          y: 233.4,
        },
        {
          x: 1764742800000,
          y: 245.49999999999997,
        },
        {
          x: 1764743100000,
          y: 234,
        },
        {
          x: 1764743400000,
          y: 183.8,
        },
        {
          x: 1764743700000,
          y: 205.5,
        },
        {
          x: 1764744000000,
          y: 217.60000000000002,
        },
        {
          x: 1764744300000,
          y: 192.1,
        },
        {
          x: 1764744600000,
          y: 214.1,
        },
        {
          x: 1764744900000,
          y: 231.6,
        },
        {
          x: 1764745200000,
          y: 242.29999999999998,
        },
        {
          x: 1764745500000,
          y: 299,
        },
        {
          x: 1764745800000,
          y: 315.70000000000005,
        },
        {
          x: 1764746100000,
          y: 280.2,
        },
        {
          x: 1764746400000,
          y: 282.1,
        },
        {
          x: 1764746700000,
          y: 289.3,
        },
        {
          x: 1764747000000,
          y: 267.3,
        },
        {
          x: 1764747300000,
          y: 293.40000000000003,
        },
        {
          x: 1764747600000,
          y: 304.59999999999997,
        },
        {
          x: 1764747900000,
          y: 280.29999999999995,
        },
        {
          x: 1764748200000,
          y: 306,
        },
        {
          x: 1764748500000,
          y: 301.6,
        },
        {
          x: 1764748800000,
          y: 226.40000000000003,
        },
        {
          x: 1764749100000,
          y: 285.4,
        },
        {
          x: 1764749400000,
          y: 310.7,
        },
        {
          x: 1764749700000,
          y: 254.59999999999997,
        },
        {
          x: 1764750000000,
          y: 293.5,
        },
        {
          x: 1764750300000,
          y: 346.09999999999997,
        },
        {
          x: 1764750600000,
          y: 297.9,
        },
        {
          x: 1764750900000,
          y: 344.6,
        },
        {
          x: 1764751200000,
          y: 353.40000000000003,
        },
        {
          x: 1764751500000,
          y: 294.2,
        },
        {
          x: 1764751800000,
          y: 344.99999999999994,
        },
        {
          x: 1764752100000,
          y: 360.40000000000003,
        },
        {
          x: 1764752400000,
          y: 312.1000000000001,
        },
        {
          x: 1764752700000,
          y: 370.70000000000005,
        },
        {
          x: 1764753000000,
          y: 361.2,
        },
        {
          x: 1764753300000,
          y: 380.5,
        },
        {
          x: 1764753600000,
          y: 377,
        },
        {
          x: 1764753900000,
          y: 364.29999999999995,
        },
        {
          x: 1764754200000,
          y: 311.6,
        },
        {
          x: 1764754500000,
          y: 356.3,
        },
        {
          x: 1764754800000,
          y: 368.1,
        },
        {
          x: 1764755100000,
          y: 318.90000000000003,
        },
        {
          x: 1764755400000,
          y: 346.9,
        },
        {
          x: 1764755700000,
          y: 345.79999999999995,
        },
        {
          x: 1764756000000,
          y: 321.70000000000005,
        },
        {
          x: 1764756300000,
          y: 364.2,
        },
        {
          x: 1764756600000,
          y: 375,
        },
        {
          x: 1764756900000,
          y: 300.90000000000003,
        },
        {
          x: 1764757200000,
          y: 360.79999999999995,
        },
        {
          x: 1764757500000,
          y: 360.8,
        },
        {
          x: 1764757800000,
          y: 381.8,
        },
        {
          x: 1764758100000,
          y: 356.1,
        },
        {
          x: 1764758400000,
          y: 404.90000000000003,
        },
        {
          x: 1764758700000,
          y: 378.9,
        },
        {
          x: 1764759000000,
          y: 377.9,
        },
        {
          x: 1764759300000,
          y: 407.2,
        },
        {
          x: 1764759600000,
          y: 329.4,
        },
        {
          x: 1764759900000,
          y: 389.99999999999994,
        },
        {
          x: 1764760200000,
          y: 379,
        },
        {
          x: 1764760500000,
          y: 297.6,
        },
        {
          x: 1764760800000,
          y: 382.5,
        },
        {
          x: 1764761100000,
          y: 375.3,
        },
        {
          x: 1764761400000,
          y: 296.29999999999995,
        },
        {
          x: 1764761700000,
          y: 372.9,
        },
        {
          x: 1764762000000,
          y: 398.4,
        },
        {
          x: 1764762300000,
          y: 328.9,
        },
        {
          x: 1764762600000,
          y: 369.59999999999997,
        },
        {
          x: 1764762900000,
          y: 377.9,
        },
        {
          x: 1764763200000,
          y: 334.5,
        },
        {
          x: 1764763500000,
          y: 384.4,
        },
        {
          x: 1764763800000,
          y: 366.70000000000005,
        },
        {
          x: 1764764100000,
          y: 302.8,
        },
        {
          x: 1764764400000,
          y: 370.3999999999999,
        },
        {
          x: 1764764700000,
          y: 370.70000000000005,
        },
        {
          x: 1764765000000,
          y: 307.80000000000007,
        },
        {
          x: 1764765300000,
          y: 350.29999999999995,
        },
        {
          x: 1764765600000,
          y: 351.6000000000001,
        },
        {
          x: 1764765900000,
          y: 287.3,
        },
        {
          x: 1764766200000,
          y: 332.7,
        },
        {
          x: 1764766500000,
          y: 342.1,
        },
        {
          x: 1764766800000,
          y: 294.8,
        },
        {
          x: 1764767100000,
          y: 352.9,
        },
        {
          x: 1764767400000,
          y: 356.40000000000003,
        },
        {
          x: 1764767700000,
          y: 285.9,
        },
        {
          x: 1764768000000,
          y: 346.3,
        },
        {
          x: 1764768300000,
          y: 333.4,
        },
        {
          x: 1764768600000,
          y: 285.4,
        },
        {
          x: 1764768900000,
          y: 371.6,
        },
        {
          x: 1764769200000,
          y: 341.6,
        },
        {
          x: 1764769500000,
          y: 278,
        },
        {
          x: 1764769800000,
          y: 341.20000000000005,
        },
      ],
    },
  ],
};

export const PIE_SAMPLE: any = {
  labels: ['Sector 1', 'Sector 2', 'Sector 3', 'Sector 4'],
  datasets: [
    {
      data: [2562, 2500, 2449, 2778],
      label: 'Perdidas por sectores',
      backgroundColor: ['#F7C76B', '#92C8A1', '#9CD0DF', '#8786D2'],
    },
  ],
};

export const CENTER_INFO_LOSSES: any = {
  center: {
    name: 'Central Distribution Center',
    ctEnergy: 0,
    ctEnergyUnit: 'kWh',
    clientConsumption: 0,
    consumptionUnit: 'kWh',
    losses: 0,
    lossesUnit: 'kWh',
    transformers: [],
  },
};

export const TRAFOS_INFO_LOSSES: any = {
  ctEnergy: 187.821,
  clientConsumption: 300,
  losses: 80,
  units: 'MWh',
  percentage: 20.5,
};

export const TOTAL_LOSSES: any = {
  ctEnergy: 187.821,
  clientConsumption: 300,
  losses: 80,
  units: 'MWh',
  percentage: 20.5,
};

export const CENTER_SNAPSHOT_LOSSES: any = {
  value: 75,
  min: 0,
  max: 100,
};

export const GET_LOSSES_BALANCE_DATA: GetLossesBalanceResponse = {
  data: {
    losses: [
      {
        centerName: 'CT PLAYA 3',
        distributorId: '6efba616-0e31-499b-a133-316476da60f0',
        centerId: '278.CTR.XX00000021',
        consumption: 30,
        energyCT: 105,
        losses: 75,
        hoursPercentage: 0,
        rsabtId: 'CIRR208225207214',
        tsabtId: 'CIRL207236551009',
        vtnId: 'CIRN211223110295',
        consumptionUnit: 'kWh',
        ctEnergyUnit: 'kWh',
        lossesUnit: 'kWh',
        lossesPercentage: 10,
      },
      {
        centerName: '0212 C.T.I.C CENTRAL 061',
        distributorId: '6efba616-0e31-499b-a133-316476da60f0',
        centerId: '278.CTR.XX00000021',
        consumption: 30,
        energyCT: 100,
        losses: 75,
        hoursPercentage: 0,
        rsabtId: 'CIRR208225207214',
        tsabtId: 'CIRL207236551009',
        vtnId: 'CIRN211223110295',
        consumptionUnit: 'kWh',
        ctEnergyUnit: 'kWh',
        lossesUnit: 'kWh',
        lossesPercentage: 10,
      },
      {
        centerName: '0106 C.T Ultzegin Kalea 3',
        distributorId: '6efba616-0e31-499b-a133-316476da60f0',
        centerId: '278.CTR.XX00000021',
        consumption: 30,
        energyCT: 100,
        losses: 50,
        hoursPercentage: 0,
        rsabtId: 'CIRR208225207214',
        tsabtId: 'CIRL207236551009',
        vtnId: 'CIRN211223110295',
        consumptionUnit: 'kWh',
        ctEnergyUnit: 'kWh',
        lossesUnit: 'kWh',
        lossesPercentage: 10,
      },
      {
        centerName: '0106 C.T Ultzegin Kalea 3',
        distributorId: '6efba616-0e31-499b-a133-316476da60f0',
        centerId: '278.CTR.XX00000021',
        consumption: 30,
        energyCT: 100,
        losses: 25,
        hoursPercentage: 0,
        rsabtId: 'CIRR208225207214',
        tsabtId: 'CIRL207236551009',
        vtnId: 'CIRN211223110295',
        consumptionUnit: 'kWh',
        ctEnergyUnit: 'kWh',
        lossesUnit: 'kWh',
        lossesPercentage: 10,
      },
      {
        centerName: 'CT PLAYA 3',
        distributorId: '6efba616-0e31-499b-a133-316476da60f0',
        centerId: '278.CTR.XX00000021',
        consumption: 30,
        energyCT: 100,
        losses: 15,
        hoursPercentage: 0,
        rsabtId: 'CIRR208225207214',
        tsabtId: 'CIRL207236551009',
        vtnId: 'CIRN211223110295',
        consumptionUnit: 'kWh',
        ctEnergyUnit: 'kWh',
        lossesUnit: 'kWh',
        lossesPercentage: 10,
      },
      {
        centerName: '0212 C.T.I.C CENTRAL 061',
        distributorId: '6efba616-0e31-499b-a133-316476da60f0',
        centerId: '278.CTR.XX00000021',
        consumption: 30,
        energyCT: 100,
        losses: 18,
        hoursPercentage: 0,
        rsabtId: 'CIRR208225207214',
        tsabtId: 'CIRL207236551009',
        vtnId: 'CIRN211223110295',
        consumptionUnit: 'kWh',
        ctEnergyUnit: 'kWh',
        lossesUnit: 'kWh',
        lossesPercentage: 10,
      },
      {
        centerName: '0106 C.T Ultzegin Kalea 3',
        distributorId: '6efba616-0e31-499b-a133-316476da60f0',
        centerId: '278.CTR.XX00000021',
        consumption: 30,
        energyCT: 100,
        losses: 7,
        hoursPercentage: 0,
        rsabtId: 'CIRR208225207214',
        tsabtId: 'CIRL207236551009',
        vtnId: 'CIRN211223110295',
        consumptionUnit: 'kWh',
        ctEnergyUnit: 'kWh',
        lossesUnit: 'kWh',
        lossesPercentage: 10,
      },
      {
        centerName: '0106 C.T Ultzegin Kalea 3',
        distributorId: '6efba616-0e31-499b-a133-316476da60f0',
        centerId: '278.CTR.XX00000021',
        consumption: 30,
        energyCT: 100,
        losses: 7,
        hoursPercentage: 0,
        rsabtId: 'CIRR208225207214',
        tsabtId: 'CIRL207236551009',
        vtnId: 'CIRN211223110295',
        consumptionUnit: 'kWh',
        ctEnergyUnit: 'kWh',
        lossesUnit: 'kWh',
        lossesPercentage: 10,
      },
      {
        centerName: 'CT PLAYA 3',
        distributorId: '6efba616-0e31-499b-a133-316476da60f0',
        centerId: '278.CTR.XX00000021',
        consumption: 30,
        energyCT: 100,
        losses: 15,
        hoursPercentage: 0,
        rsabtId: 'CIRR208225207214',
        tsabtId: 'CIRL207236551009',
        vtnId: 'CIRN211223110295',
        consumptionUnit: 'kWh',
        ctEnergyUnit: 'kWh',
        lossesUnit: 'kWh',
        lossesPercentage: 10,
      },
      {
        centerName: '0212 C.T.I.C CENTRAL 061',
        distributorId: '6efba616-0e31-499b-a133-316476da60f0',
        centerId: '278.CTR.XX00000021',
        consumption: 30,
        energyCT: 100,
        losses: 18,
        hoursPercentage: 0,
        rsabtId: 'CIRR208225207214',
        tsabtId: 'CIRL207236551009',
        vtnId: 'CIRN211223110295',
        consumptionUnit: 'kWh',
        ctEnergyUnit: 'kWh',
        lossesUnit: 'kWh',
        lossesPercentage: 10,
      },
    ],
  },
  pagination: {
    currentPage: 10,
    currentItems: 1,
    perPage: 10,
    totalPages: 1,
    totalItems: 10,
  },
};
